import styled from 'styled-components';

export const TimelineHeaderContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  height: 7.5rem;
  position: sticky;
  top: ${({ theme }) => theme.fixedPositions.timeLine};
  z-index: ${({ theme }) => theme.zIndex.stickyTimeline};

  ${({ isSticky }) =>
    !isSticky &&
    `
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    `}
`;

export const Corner = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-left-radius: 12px;
  justify-content: space-between;
  display: flex;
  padding-left: 1rem;
  position: sticky;
  top: ${({ theme }) => theme.fixedPositions.timeLine};
  width: ${({ theme }) => theme.constantWidths.timelineHeader};
`;
